import React from 'react';
import 'react-spring-bottom-sheet/dist/style.css'
import styled from 'styled-components';
import {Button, useToast} from "@chakra-ui/react";
import {Header, Title} from "../sheet";
import useFeedback from "../../../utils/use_feedback";
import {useCancelSubscription} from "../../../api/payments";

const CancelProSheet = styled(({className, onClose}) => {

        const toast = useToast();

        const {error, feedbackCh} = useFeedback();
        const cancelSubscription = useCancelSubscription(feedbackCh);

        const handleConfirmation = async () => {
            try {
                await cancelSubscription();
                toast({
                    title: `Your subscription has been cancelled.`,
                    status: 'success',
                    isClosable: true,
                });
                onClose();
                return;
            } catch {
            }
            toast({
                title: `Something went wrong.`,
                status: 'error',
                isClosable: true,
            });
        };

        return (
            <div className={className}>

                <Header>
                    <Title>Cancel Pro</Title>
                </Header>

                <p>
                    Your support is invaluable in helping us continue to provide a platform.
                </p>
                <p style={{marginTop: 8}}>
                    Are you sure you want to cancel your subscription?
                </p>

                <Button variant="blue" mb={2} mt={6} width={"100%"} onClick={handleConfirmation}>
                    Yes
                </Button>
                <Button variant="grey" width={"100%"} onClick={onClose}>
                    No
                </Button>

            </div>
        );
    }
)`
  p {
    font-size: 17px;
  }
`;

export default CancelProSheet;
